var _rect, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLigneBrisee11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 585,
    height: 31,
    viewBox: "0 0 585 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_731_208",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 585,
    height: 31
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 585,
    height: 31,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_731_208)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_731_208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5 6.78526L101.65 20.4122L315.765 3L502.199 24.1975L588.496 12.0846L581.169 563.976H-5V6.78526Z",
    fill: "#51276C"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_731_208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.37402 6.14008L116.138 22.0382L329.959 4.62598L516.138 25.8234L595 15.2247V565.602H9.63411L-3.37402 6.14008Z",
    fill: "#FFBA08"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-0.12207 10.0372L106.382 23.6642L320.203 6.25195L506.382 27.4494L585.244 16.8507V567.228H-0.12207V10.0372Z",
    fill: "#F9FBFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_731_208",
    x: -9,
    y: -1,
    width: 601.496,
    height: 568.976,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_731_208"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_731_208",
    x: -7.37402,
    y: 0.625977,
    width: 606.374,
    height: 568.976,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_731_208"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLigneBrisee11);
export default __webpack_public_path__ + "static/media/ligne_brisee_1.1.ca25da3987be67c7d6b999220b453bd3.svg";
export { ForwardRef as ReactComponent };